import { Box, Button, Drawer, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { AmountsCard } from '../../../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import { Colors } from '../../../../../Styles/Colors';
import { withTranslation } from 'react-i18next';
import { AmountFormat } from '../../../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../../../Utility/Constants';
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import { DateTime } from 'luxon';
import Loader from '../../../../../Components/Loader';
import PharmaFilter from '../../PharmaFilter';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';

function NetGSTReport(props) {
    const [states, setStates] = React.useState({
        totalTaxAmt: 0,
        totalGstAmt: 0,
        filterOpen: false,
        disabled: false,
        netGstData: [],
        page: 0,
        rowsPerPage: 10,
        totalCount: 0,
        pageName: 'netgst_report',
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        isLoader: false,
        filterDatas: {
            'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            "dateIndex": 1,
        }
    });

    useEffect(() => {
        getNetGSTReportData();
    }, []);

    const errorMessage = (msg) => {
        setStates(prev => ({
            ...prev,
            isErrorMsg: true,
            isErrorMsgText: msg,
            isLoader: false
        }));
    }
    const successMessage = (msg) => {
        setStates(prev => ({
            ...prev,
            successMsg: true,
            successMsgText: msg,
            isLoader: false
        }));
    }

    const getNetGSTReportData = () => {
        try {
            setStates(prev => ({ ...prev, isLoader: true }));
            RestAPIService.getAll(`${Serviceurls.NET_GST_REPORT}?page=${states.page + 1}&page_size=${states.rowsPerPage}&from_date=${states.filterDatas.fromDate}&to_date=${states.filterDatas.toDate}`)
            .then((response) => {
                if(response.data.status === 'success'){
                    setStates(prev => ({
                        ...prev,
                        netGstData: response.data?.data || [],
                        totalTaxAmt: response.data?.total_taxable_amount || 0,
                        totalGstAmt: response.data?.total_gst_amount || 0,
                        totalCount: response.data?.total_count || 0,
                            isLoader: false
                    }))
                }
            })
            .catch((e) => {
                setStates(prev => ({ ...prev, isLoader: false }));
                errorMessage(e.response?.data?.message || e.message)
            })
        }catch(e){
            setStates(prev => ({ ...prev, isLoader: false }));
            errorMessage(e.message)
        }
    }

    const getNetGSTReportExport = () => {
            try {
                setStates({ ...states, disableBtn: true })
                RestAPIService.excelGet(`${Serviceurls.NET_GST_REPORT}?from_date=${states.filterDatas.fromDate}&to_date=${states.filterDatas.toDate}&export_type=excel`).
                    then((response) => {
                        if (response.data) {
                            var pom = document.createElement('a');
                            var csvContent = response.data; //here we load our csv data 
    
                            let filename = response?.headers["content-disposition"]?.split("filename=")[1]
                            // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});
    
                            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                            var url = URL.createObjectURL(blob);
                            pom.href = url;
                            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                            pom.click();
                            setStates({ ...states, disableBtn: true })
                        }
                    }).catch((error) => {
                        if (error.response?.data?.message) {
                            errorMessage(error.response?.data?.message);
                        } else {
                            errorMessage(error.message);
                        }
                        setStates({ ...states, disableBtn: true })
                    })
            } catch (error) {
                errorMessage(error.message);
                setStates({ ...states, disableBtn: true })
            }
        }

    const handlePageChange = (event, newPage) => {
        setStates(prev => ({ ...prev, page: newPage }));
    }

    const handleRowsPerPageChange = (event) => {
        setStates(prev => ({
            ...prev,
            rowsPerPage: event.target.value,
            page: 0
        }));
    }

    const renderTable = () => {
        const { t } = props;
        return (
            <Box component={'div'}>
                <Paper sx={{ width: '100%', height: '100%' }}>
                    <TableContainer sx={{ height: '55vh' }}>
                        <Table stickyHeader size='small' aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell id='eMed_config_TableRow1' sx={{ borderRight: '1px solid #CBCBCB' }} rowSpan={2}>{t('Date')}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='center' colSpan={2}>0%</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='center' colSpan={2}>5%</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='center' colSpan={2}>12%</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='center' colSpan={2}>18%</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='center' sx={{ borderRight: '1px solid #CBCBCB' }} colSpan={2}>{"Others"}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' rowSpan={2}>{`${t('Totaltacamo') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' rowSpan={2}>{`${t('TotalGSTAmount') + `(${CurrencySymbol})`}`}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw' }} >{`${t('TaxAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw', borderRight: '1px solid #CBCBCB' }}>{`${t('gstAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw' }}>{`${t('TaxAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw', borderRight: '1px solid #CBCBCB' }}>{`${t('gstAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw' }} >{`${t('TaxAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw', borderRight: '1px solid #CBCBCB' }}>{`${t('gstAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw' }}>{`${t('TaxAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw', borderRight: '1px solid #CBCBCB' }}>{`${t('gstAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw' }}>{`${t('TaxAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                    <TableCell id='eMed_config_TableRow1' align='right' sx={{ position: 'sticky', top: '2.35vw', borderRight: '1px solid #CBCBCB' }}>{`${t('gstAmt') + `(${CurrencySymbol})`}`}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {states.netGstData
                                    .map((data) => {
                                        return (
                                            <TableRow>
                                                <TableCell align='right' sx={{ borderRight: '1px solid #CBCBCB' }}>{data?.invoice_date?.length > 7 ?
                                                    <Tooltip title={data?.invoice_date} placement='top'><Typography>{data.invoice_date ? data.invoice_date.slice(0, 5) + "..." : '-'}</Typography></Tooltip> :
                                                    <Typography>{data.invoice_date ? data.invoice_date : '-'}</Typography>}</TableCell>
                                                <TableCell align='right'>{AmountFormat(data.zero_dict.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right' sx={{ borderRight: '1px solid #CBCBCB' }}>{AmountFormat(data.zero_dict.gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right'>{AmountFormat(data.five_dict.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right' sx={{ borderRight: '1px solid #CBCBCB' }}>{AmountFormat(data.five_dict.gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right'>{AmountFormat(data.twelve_dict.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right' sx={{ borderRight: '1px solid #CBCBCB' }}>{AmountFormat(data.twelve_dict.gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right'>{AmountFormat(data.eighteen_dict.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right' sx={{ borderRight: '1px solid #CBCBCB' }}>{AmountFormat(data.eighteen_dict.gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right'>{AmountFormat(data.other_dict?.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right' sx={{ borderRight: '1px solid #CBCBCB' }}>{AmountFormat(data.other_dict?.gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right' >{AmountFormat(data.total_taxable_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                                <TableCell align='right'>{AmountFormat(data.total_gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {states.netGstData.length === 0 ?
                            <div className='eMed_TestConfig_NoRecords'>
                                {t('NoRecordsFound')}
                            </div> : null}
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={states.totalCount}
                        rowsPerPage={states.rowsPerPage}
                        page={states.page}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                    />
                </Paper>
            </Box>
        )
    }

    const ClosePopUp = () => {
        setStates(prev => ({ ...prev, filterOpen: false }));
    }

    const renderFilter = (data) => {
        setStates(prev => ({ ...prev, filterDatas: data, filterOpen: false, page: 0 }));
    }

    useEffect(() => {
        getNetGSTReportData();
    }, [states.page, states.rowsPerPage, states.filterDatas]);

    const clearFilter = (data) => {
        setStates(prev => ({ ...prev, filterDatas: data, }))
    }

    const msgClose = () => {
        setStates(prev => ({ ...prev, isErrorMsg: false, isErrorMsgText: '', successMsg: false, successMsgText: '' }));
    }

    return (
        <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
            <Box component={'div'} className='eMed_Pharma_rts_header'>
                <Box component={'div'} flex={0.8} display={'flex'}>
                    {AmountsCard("Net Taxable Amount", states.totalTaxAmt, false, "white", false, null, "net_tax_amt")}
                    {AmountsCard("Net GST Amount", states.totalGstAmt, false, "white", false, null, "Net_gst_amt")}
                </Box>
                <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'}>
                    <IconButton emed_tid={states.status === "hsn_summary" ? "dayHsn_sum_flt" : "dayGst_sum_flt"} className='eMed_Pharma_rts_btn' onClick={() => setStates({ ...states, filterOpen: true })}>
                        <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' height={'2.3vw'} width={'2.3vw'} />
                    </IconButton>
                    <Button emed_tid="DayWise_print" className='eMed_Pharma_rts_btn' disabled={states.disabled} onClick={() => {getNetGSTReportExport()}}>
                        <Box component={'img'} src={ImagePaths.ExportIcon.default} alt='export' height={'2.3vw'} width={'2.3vw'} />
                    </Button>
                </Box>
            </Box>
            <Box component={'div'} className='eMed_Pharma_rts_tbl_card'>
                {renderTable()}
            </Box>
            <Drawer
                anchor={'right'}
                open={states.filterOpen}
                ModalProps={{ onBackdropClick: ClosePopUp.bind(this) }}
            >
                <PharmaFilter pageName={states.pageName} filterDatas={states.filterDatas} closeFilter={ClosePopUp.bind(this)} filteredData={renderFilter.bind(this)} ClearData={clearFilter.bind(this)} />
            </Drawer>
            {states.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={states.isErrorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {states.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={states.successMsgText}
                    msgPop={this.msgClose.bind(this)}
                />
                : null}
            <Loader loaderOpen={states.isLoader} />
        </Box>
    )
}

export default withTranslation()(NetGSTReport);